import React from "react";
import Video from "../../asset/vid/save-featured-video-2.webm";
import './style.css';

const Section3 = () => {
  const [fS, setFS] = React.useState(3);
  const [lH, setLH] = React.useState(1.5);
  React.useEffect(() => {
    window.innerWidth < 768 ? setFS(2) : setFS(3);
    window.innerWidth < 768 ? setLH(1.2) : setLH(1.2);
  }, [fS, lH]);

  return (
    <>
      <div className="section-3">
        <div className="col-12 px-3 px-lg-3 py-4 py-lg-5 
          d-flex flex-column flex-lg-row align-items-center">
          <div className="col-12 col-lg-7 pt-4 pt-lg-0 pe-0 pe-lg-5">
            <div className="ratio ratio-16x9">
              <video className="w-100" src={Video} autoPlay muted loop style={{border: `solid 1px rgb(82, 84, 109)`}}/>
            </div>
          </div>
          <div className="col-12 col-lg-5 ps-0 ps-lg-4 mt-5 mt-lg-0 text-center text-lg-start">
            <div className="fw-bold card-title"
              style={{fontSize: `${fS}rem`, lineHeight: `${lH}`}}>
              How SAVE Works So Smoothly
            </div>
            {/* <div className="horizontal-line"></div> */}
            <div className="py-3 body"></div>
            <p className="fs-4 fw-light card-text">Let’s take a look at how SAVE works.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section3;